import { FieldsNameVoc } from 'constants/auth/profile-data'

const FieldCode = 'codeReg'
const FieldId = 'id'
const isAdAgree = 'isAdAgree'
const isUserAgree = 'isUserAgree'

type FormValues = {
  // Определите здесь структуру ваших данных формы
  [FieldsNameVoc.phone]: string
  [FieldsNameVoc.countryCode]: string
  [FieldsNameVoc.email]: string
  [FieldsNameVoc.Specialities]: []
  [FieldsNameVoc.fullName]: ''
  [FieldsNameVoc.workplace]: ''
  [isAdAgree]: boolean
  [isUserAgree]: boolean
  [FieldCode]: string
  [FieldId]: number
}

enum RegStep {
  START = 'start',
  EMAIL_WIDGET = 'email',
  NEW_REG_FLOW = 'newregflow',
  PHONE_FLOW_OK = 'phoneflowOk',
  EMAIL_FLOW_OK = 'emailflowOk',
  PHONE_FLOW_NOREG = 'phoneflowNoreg',
  NO_ATTEMPTS_PHONE = 'noattemptsPhone',
  NO_ATTEMPTS_EMAIL = 'noattemptsEmail',
  DOP_INPUTS = 'dopInputs',
  ERROR = 'error',
}

export type { FormValues }
export { RegStep, FieldCode, FieldId, isAdAgree, isUserAgree }
